import React, { useEffect, useState } from 'react'
import CardLoadingPage from '../../components/CardLoadingPage/CardLoadingPage';
import CustomModal from '../../components/CustomModal/CustomModal';
import { useSelector } from 'react-redux';
import {ROLES} from '../../model/roles'
import useAgenzie from '../../hooks/useAgenzie';
import CreateAgenziaForm from '../../components/Forms/CreateAgenziaForm/CreateAgenziaForm';
import UtilityService from '../../services/UtillityServices/UtilityService';
import AgenziaInfo from '../../components/AgenziaInfo/AgenziaInfo'; 
import { Dropdown, OverlayTrigger, Placeholder, Table, Tooltip } from 'react-bootstrap';
import useMediaQuery from '../../hooks/useMediaQuery';
import { alertService } from '../../services/AlertService';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import CustomTable from '../../components/CustomTable/CustomTable';
import useAgenziaConfigTable from '../../configTable/useAgenziaConfigTable';
import { ACTION_TYPES } from '../../model/actions';

const GestioneAgenziePage = () => {
  const {
    getAgenzieByParams,
    loadingStateAgenzie,
    createAgenzia, 
    deleteAgenzia,
    modalStateAgenzie,
    setModalStateAgenzie,
    updateAgenzia,
  } = useAgenzie();

  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const [agenzie, setAgenzie] = useState([]);
  const [selectedAgenzia, setSelectedAgenzia] = useState(null);
  const [formCreateAgenzia, setFormCreateAgenzia] = useState({});

  const [orderBy, setOrderBy] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1); 
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingAgenzie, setIsLoadingAgenzie] = useState(false);
  const agenziaConfigTable = useAgenziaConfigTable();

  useEffect(() => {
    if (!isLoadingAgenzie) {
      printAllAgenzie();
    }
  }, [orderBy, orderType, selectedPage]);
  
  const fetchAgenzie = async (obj) => {
    setIsLoadingAgenzie(true);
  
    obj = {
      ...obj,
      filtri: {
        ...obj.filtri,
      }
    };
  
    const fetchAgenzieList = await getAgenzieByParams(obj);
    const countPagination = Math.ceil(fetchAgenzieList?.count / obj.limite);
    let agenzieList = fetchAgenzieList?.data ?? [];
    setTotalPages(countPagination);
    setAgenzie(agenzieList);
    setIsLoadingAgenzie(false);
    if(agenzieList?.length === 0){
      setSelectedPage(1)
    }
  }
  
  const printAllAgenzie = async () => {
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: `${orderBy ?? "denominazione"} ${orderType ?? "asc"}`
    };
  
    await fetchAgenzie(obj);
  };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
  
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: 1,
      ordinamento: `${orderBy ?? "denominazione"} ${orderType ?? "asc"}`
    };
  
    await fetchAgenzie(obj);
  };

  const openInfoModal = (agenzia) => {
    setSelectedAgenzia(agenzia)
    setModalStateAgenzie(state => ({ ...state, showModalInfoAgenzia: true }));
  }

  const openEditModal = (agenzia) => {
    setSelectedAgenzia(agenzia)
    setFormCreateAgenzia(agenzia);
    setModalStateAgenzie(state => ({ ...state, showModalUpdateAgenzia: true }));
  }

  const openDeleteModal = (agenzia) => {
    setSelectedAgenzia(agenzia)
    setModalStateAgenzie(state => ({ ...state, showModalDeleteAgenzia: true }));
  }

  const handleCloseModal = () => {
    setModalStateAgenzie(state => ({ 
       ...state,
       showModalCreateAgenzia: false, 
       showModalInfoAgenzia: false, 
       showModalDeleteAgenzia: false,
       showModalUpdateAgenzia: false,
      }));
  }

  const openModalCreateAgenzia = () => {
    setModalStateAgenzie(state => ({ ...state, showModalCreateAgenzia: true }));
  }

  const renderSelectedDeleteAgenzia = () => {
    return (
      <>
      <span className="d-block fs-4 mb-2"><b>Vuoi eliminare la seguente agenzia?</b> </span>
      <span className="d-block fs-5">{selectedAgenzia?.denominazione} - {selectedAgenzia?.indirizzo}, {selectedAgenzia?.cap}, {selectedAgenzia?.citta}, {selectedAgenzia?.provincia}</span>
      </>
    )
  }

  const onCreateAgenzia = async () => {
      const requiredFields = ["denominazione", "indirizzo", "cap", "citta", "provincia", "piva"];
      const missingFields = UtilityService.validationForm(formCreateAgenzia, requiredFields);
      if (missingFields?.length > 0) {
          alertService.warn(`I seguenti campi sono obbligatori: ${missingFields}`, {autoClose: true});
          return;
      }

      const res = await createAgenzia(formCreateAgenzia);
      if(res) {
        printAllAgenzie();
      }

  };

  const onDeleteAgenzia = async () => {
    const obj = {id_agenzia: selectedAgenzia?.id_agenzia}
    const res = await deleteAgenzia(obj);
    if(res) {
      printAllAgenzie();
    }
  }

  const onUpdateAgenzia = async () => {
    const obj = {
      ...formCreateAgenzia,
      id_agenzia: selectedAgenzia?.id_agenzia
    }
    const res = await updateAgenzia(obj);
    if(res) {
      printAllAgenzie();
     }
  }

  const handleOrder = (orderBy, orderType) => {
    setOrderBy(orderBy);
    setOrderType(orderType);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const actions = [
    {
      label: ACTION_TYPES.DETAILS,
      icon: 'bi-info-circle text-dark',
      tooltip: ACTION_TYPES.DETAILS,
      type: ACTION_TYPES.VIEW,
      condition: () => true,
      onClick: (agenzia) => openInfoModal(agenzia)
    },
    {
      label: ACTION_TYPES.UPDATE,
      icon: 'bi-pencil-fill text-warning',
      tooltip: ACTION_TYPES.UPDATE,
      type: ACTION_TYPES.MANAGER,
      condition: () => true,
      onClick: (agenzia) => openEditModal(agenzia)
    },
    {
      label: ACTION_TYPES.DELETE,
      icon: 'bi-trash-fill text-danger',
      tooltip: ACTION_TYPES.DELETE,
      type: ACTION_TYPES.MANAGER,
      condition: () => true,
      onClick: (agenzia) => openDeleteModal(agenzia)
    }
  ];

  return (
    <>
        <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`} style={{minHeight: '700px'}}>
            <div className='container'>
              <div className='d-flex justify-content-between custom-card-header'>
                <div className='d-flex gap-3 custom-card-title my-2'>
                  <div className={`custom-icon-container`}>
                    <i className={`bi custom-icon bi-building fs-2`}></i>
                  </div>
                  <div className='align-self-center'>
                    <span className='fs-4 d-block'><i><b>Gestione agenzie</b></i></span>
                  </div>
                </div>
                <div className='align-self-center my-2'>
                  <button type='button' className='btn btn-primary' onClick={openModalCreateAgenzia}>Crea agenzia</button>
                </div>
              </div>
              <div className='mt-5'>
                <CustomFilterTable 
                  formDataFilter={formDataFilter}
                  setFormDataFilter={setFormDataFilter}
                  onFilteredTable={onFilteredTable}
                  isLoadingData={loadingStateAgenzie.isLoadingAgenzieByParams}
                  searchNodeType={[
                    {nodeType: "input", name: "denominazione", placeholder: "ragione sociale"},
                    {nodeType: "input", name: "indirizzo"},
                    {nodeType: "input", name: "cap"},
                    {nodeType: "input", name: "citta"},
                    {nodeType: "input", name: "provincia"},
                    {nodeType: "input", name: "piva", placeholder: "partita iva"},
                    {nodeType: "input", name: "referente"}
                  ]}
                />
              </div>
              {  !loadingStateAgenzie.isLoadingAgenzieByParams ? ( 
                  <>
             {(!agenzie || agenzie?.length === 0) ? (
                    <div className='mt-5 pt-5 text-center'>
                        <p>Non ci sono agenzie da mostrare.</p>
                    </div>) : (
                      <>
              <CustomTable
                data={agenzie}
                actions={actions}
                columns={agenziaConfigTable}
                handleOrder={handleOrder}
                orderBy={orderBy}
                orderType={orderType}
              />
              <div className="d-flex justify-content-end mt-1">
                <CustomPagination
                  totalPages={totalPages}
                  selectedPage={selectedPage}
                  handlePageChange={handlePageChange}
                />
              </div>
                      </>

                    )}
                  </>
              ) : (
                <LoadingTable loadingCol={7} />
              ) }
              <>
              </>
            </div>
        </div>
         <CustomModal
          show={modalStateAgenzie.showModalCreateAgenzia}
          onHide={handleCloseModal}
          headerText="Crea agenzia"
          size={"lg"}
          btnText={"Crea agenzia"}
          body={<CreateAgenziaForm 
            formCreateAgenzia={formCreateAgenzia}
            setFormCreateAgenzia={setFormCreateAgenzia}
            showModalCreateAgenzia={modalStateAgenzie.showModalCreateAgenzia}
          />} 
          isLoading={loadingStateAgenzie.isLoadingAgenziaCreating}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onCreateAgenzia} 
        />
         <CustomModal
          show={modalStateAgenzie.showModalUpdateAgenzia}
          onHide={handleCloseModal}
          headerText="Modifica agenzia"
          size={"lg"}
          btnText={"Salva modifiche"}
          body={<CreateAgenziaForm 
            formCreateAgenzia={formCreateAgenzia}
            setFormCreateAgenzia={setFormCreateAgenzia}
            showModalCreateAgenzia={modalStateAgenzie.showModalUpdateAgenzia}
          />} 
          isLoading={loadingStateAgenzie.isLoadingAgenziaUpdate}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onUpdateAgenzia} 
        />
         <CustomModal
          show={modalStateAgenzie.showModalDeleteAgenzia}
          onHide={handleCloseModal}
          headerText="Elimina agenzia"
          size={"md"}
          variant={"danger"}
          btnText={"Elimina"}
          body={renderSelectedDeleteAgenzia()} 
          isLoading={loadingStateAgenzie.isLoadingAgenziaDelete}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onDeleteAgenzia} 
        />
         <CustomModal
          show={modalStateAgenzie.showModalInfoAgenzia}
          onHide={handleCloseModal}
          headerText="Informazioni agenzia"
          size={"lg"}
          hideSaveBtn={true}
          body={<AgenziaInfo agenziaData={selectedAgenzia} />} 
          closeButton={true}
          onUndoChanges={handleCloseModal}
        />
      </>
  )
}

export default GestioneAgenziePage;